<template>
  <div>
    <div class="container">
      <br />
      <el-row :gutter="20">
        <el-col :span="6" class="m-el-menu">
          <p style="font-weight: bold; color: black; font-size: 30px">
            联系方式
          </p>
          <div class="underline"></div>
          <br />
          <p>
            <img
              src="../../../assets/ContactUs/locationIcon.png"
              style="height: 20px; width: 20px"
            />
            地址：
          </p>
          <!-- <p>  澳岚丁（无锡）生物科技有限公司 </p>
         //由Aulandin@163.com变更为ald0807@163.com
        <P> Email: &nbsp; ald0807.com </P> -->
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;江苏省无锡市新吴区新区新安街道清晏路
          </p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;99号立业楼D栋四楼418-419室</p>
          <p>
            <img
              src="../../../assets/ContactUs/email.png"
              style="height: 20px; width: 20px"
            />
            联系方式：
          </p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ald0807@163.com</p>
        </el-col>
        <el-col :span="18" class="m-el-page">
          <p style="font-weight: bold; color: black; font-size: 30px">
            联系我们
          </p>
          <div class="underline"></div>
          <br />
          <TMmap
            ref="map"
            v-if="mapShow"
            :position="list"
            @PositionDegrees="degrees"
          ></TMmap>
          <br />
          <el-input
            v-model="dataMap.name"
            placeholder="姓名*"
            class="rounded-input"
          />
          <el-input
            v-model="dataMap.unit"
            placeholder="单位*"
            class="rounded-input"
          />
          <el-input
            v-model="dataMap.email"
            placeholder="Email*"
            class="rounded-input"
          />
          <el-input
            v-model="dataMap.phone"
            placeholder="电话*"
            class="rounded-input"
          />
          <el-input
            v-model="dataMap.desc"
            maxlength="60"
            placeholder="咨询内容*"
            show-word-limit
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 10 }"
          />
          <div
            style="
              display: flex;
              justify-content: left;
              margin-top: 20px;
              margin-bottom: 20px;
            "
          >
            <el-button
              color="#626aef"
              :dark="isDark"
              plain
              class="rounded-button"
              @click="submitProductConsult"
              >提交信息</el-button
            >
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="bottom">Copyright © 2024 澳岚丁生物科技有限公司</div>
  </div>
</template>

<script>
import TMmap from "./TMmap/index.vue";
import {
  getSubmitProductConsultUrl,
  recordDetailInfo,
} from "../../../request/request";
import request from "superagent";

export default {
  mounted() {
    this.list.lng = 120.37;
    this.list.lat = 31.48;
    this.mapShow = true;
    // 加载完成调用
    this.$nextTick(() => {
      this.$refs.map.MapResetting();
    });
    recordDetailInfo("联系我们");
  },
  components: { TMmap },
  data() {
    return {
      list: {},
      mapShow: false,
      pageCount: null,
      dataMap: {
        name: "",
        unit: "",
        email: "",
        phone: "",
        desc: "",
      },
    };
  },
  methods: {
    hasEmptyOrNull(data) {
      let returnMessage = "";
      for (let key in data) {
        if (data[key] === "" || data[key] === null) {
          returnMessage = "请填写完毕内容再提交!";
          return returnMessage;
        }
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (emailRegex.test(data.email) == false) {
        returnMessage = returnMessage + "请填写正确的邮箱账号!";
        return returnMessage;
      }
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (phoneRegex.test(data.phone) == false) {
        returnMessage = returnMessage + "请填写正确的电话号码!";
        return returnMessage;
      }
      return returnMessage;
    },
    submitProductConsult() {
      let message = this.hasEmptyOrNull(this.dataMap);
      if (message != "") {
        this.$notify({
          title: "提示",
          message: message,
          type: "warning",
        });
        return;
      }
      request
        .post(getSubmitProductConsultUrl())
        .send({
          dataMap: this.dataMap,
          ipInfo: JSON.parse(sessionStorage.getItem("ipInfo")),
        })
        .end((err, res) => {
          if (err) {
            this.$notify.error({
              title: "错误",
              message: err,
            });
          } else {
            for (let key in this.dataMap) {
              if (this.dataMap.hasOwnProperty(key)) {
                this.dataMap[key] = "";
              }
            }
            console.log(res.body);
            if (res.body.code == 0) {
              this.$notify({
                title: "警告",
                message: res.body.msg,
                type: "warning",
              });
              return;
            }
            this.$notify({
              title: "提示",
              message: res.body.data,
              type: "success",
            });
          }
        });
    },
  },
};
</script>

<style scoped lang="less">
.rounded-button {
  border-radius: 10px; /* 你可以根据需要调整这个值 */
  width: 255px; /* 设置按钮的宽度 */
  background-color: rgb(38, 186, 236);
}

.rounded-input {
  margin-bottom: 20px; /* 设置下边距 */
  border-radius: 50px; /* 你可以根据需要调整这个值 */
  width: 445px;
}

.box-card-small {
  width: 100%;
  text-align: left;
  background-color: #ffffff;
  padding: 0px;
  color: black;
  font-size: 24px;
  margin: 0px; /* 添加间距 */
  height: 450px;
}

.underline {
  position: relative;
  width: 100%; /* 下划线的宽度 */
  height: 2px; /* 下划线的高度 */
  background: linear-gradient(
    to right,
    rgb(4, 196, 244) 33%,
    gray 33%
  ); /* 渐变效果 */
}

.bottom {
  background: #f7fbfd;
  text-align: center;
  color: #ababab;
  height: 72px;
  padding-top: 32px;
}

.contact-us {
  padding-top: 55px;
  .h2 {
    font-size: 28px;
  }
  .h3 {
    font-size: 22px;
  }
  dl {
    margin-bottom: 72px;
    dd {
      margin-top: 18px;
    }
    .weixin {
      display: inline-block;
      width: 162px;
      height: 162px;
    }
  }
  .mr32 {
    margin-right: 32px;
  }
  .ml32 {
    margin-left: 32px;
  }
}
.bottom-side {
  color: #ababab;
  margin-top: 100px;
  height: 68px;
  background: #f7fbfd;
  text-align: center;
  padding-top: 32px;
}

@media (max-width: 768px) {
  .contact-us {
    .mr32,
    .ml32 {
      margin-right: 0;
      margin-left: 0;
    }
    dl {
      text-align: center !important;
    }
    dt {
      margin-right: 0 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/content/contactUs/contactUs.vue